class PermissionsBase {
  validate(permission) {
    return this.permissions[permission] || false;
  }
}

PermissionsBase.prototype.permissions = {};

export default PermissionsBase;
